<template>
		<v-menu
			ref="projectTypeSelectMenu"
			offset-y
			right
			:close-on-content-click="false"
			max-width="500"
			min-width="500"
			content-class="menu-bg-white"
			:style="{ zIndex: 9999, backgroundColor: 'white', pointerEvents: isDisabled ? 'none' : 'auto' }">
			<template v-slot:activator="{ on: menuOn, attrs: menuAttrs }">
				<v-tooltip bottom>
					<template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
						<v-text-field
							v-bind="{ ...menuAttrs, ...tooltipAttrs }"
							v-on="{ ...menuOn, ...tooltipOn }"
							:readonly="true"
							:disabled="isDisabled"
							:value="selectedProjectType
								? projectTypeSubtitle + ' | ' + selectedProjectType.name
								: 'Selecciona Tipo Proyecto'"
							:label="inputLabel"
							:class="denseInput ? 'caption custom-height-search custom-height-calendar' : ''"
							:style="{ minWidth: '250px', pointerEvents: isDisabled ? 'none' : 'auto' }"
							dense
							outlined
							hide-details
						>
							<template v-slot:append>
								<v-icon v-on="menuOn" :style="isDisabled ? 'pointer-events: none;' : 'cursor: pointer;'">mdi-menu-down</v-icon>
							</template>
						</v-text-field>
					</template>

					<span>
						{{ selectedProjectType
							? projectTypeSubtitle + ' | ' + selectedProjectType.name
							: 'Selecciona Tipo Proyecto' }}
					</span>
				</v-tooltip>
			</template>
			<!-- <template v-slot:activator="{ on, attrs }">
				<v-text-field
					v-bind="attrs"
					v-on="on"
					:readonly="true"
					:disabled="isDisabled"
					:value="selectedProjectType ? projectTypeSubtitle + ' | ' + selectedProjectType.name:'Selecciona Tipo Proyecto'"
					label="Proyecto"
					class="custom-height-search custom-height-calendar caption"
					style="min-width: 250px;"
					dense
					outlined
					hide-details
				>
					<template v-slot:append>
						<v-icon>mdi-chevron-down</v-icon>
					</template>
				</v-text-field>
			</template> --><!-- Contenedor principal -->
			<div style="position: relative; height: 400px; background-color: white; z-index: 9999;">
				<!-- Header fijo fuera del v-list -->
				<div 
					class="d-flex align-center justify-space-between mb-1 px-4" 
					style="
						position: absolute; 
						top: 0; 
						left: 0; 
						right: 0; 
						min-height: 25px; 
						background: #524D4D; 
						z-index: 1001;
					"
				>
					<p class="caption mb-0 font-weight-bold white--text">Cambiar Tipo de Proyecto</p>
					<div>
						<v-text-field
							v-model="searchProjectTypeInput"
							outlined
							dense
							hide-details
							label="Búsqueda"
							class="custom-height-search custom-height-calendar"
							dark
							color="white"
						></v-text-field>
					</div>
				</div>

				<!-- Lista scrolleable con padding-top para compensar el header -->
				<v-list 
					dense 
					class="py-0" 
					style="
						height: 100%; 
						overflow-y: auto; 
						padding-top: 60px !important;
					"
				>
					<v-list-item-group color="#524D4D" v-for="category in companiesProjectTypesCategories" :key="'pt_'+category.id">
						<v-subheader class="grey lighten-2 black--text font-weight-bold">{{ category.name }}</v-subheader>
						<v-list-item
							v-for="(project_type, index) in category.project_types"
							:key="index"
							dense
							@click.stop="projectTypeChange(project_type)"
						>
							<v-list-item-content>
								<v-list-item-title dense>
									<div class="d-flex align-center justify-space-between">
										{{ project_type.name }}
										<v-btn
											text
											small
											v-if="project_type.sub_types?.length > 0 && !fullView"
											@click.stop="handleOpenSubTypes(project_type)"
										>
											<div class="d-flex align-center justify-space-between">
												<p class="mb-0 caption text--disabled">Subtipos</p>
												<v-icon dark v-if="hideSubTypes.includes(project_type.id)">mdi-chevron-up</v-icon>
												<v-icon dark v-else>mdi-chevron-down</v-icon>
											</div>
										</v-btn>
									</div>
								</v-list-item-title>
								<v-list-item
									v-for="(sub_type, index) in project_type.sub_types"
									:key="index"
									v-show="hideSubTypes.includes(project_type.id) || fullView"
									dense
									@click.stop="projectTypeChange(sub_type)"
								>
									<v-list-item-content>
										<v-list-item-title dense>
											<p class="text--disabled mb-1" style="font-size: 10px;line-height: 10px">{{ project_type.name }}</p>
											<div class="d-flex align-center justify-space-between">
												{{ sub_type.name }}
											</div>
										</v-list-item-title>
									</v-list-item-content>
								</v-list-item>
							</v-list-item-content>
						</v-list-item>
					</v-list-item-group>
				</v-list>
			</div>
		</v-menu>
</template>

<script>
export default {
	name: "ProjectTypeSelectorMenuSelect",
	props: {
		projectType: {
			type: Object,
			default: null
		},
		onClick: {
			type: Function,
			required: true
		},
		isDisabled: {
			type: Boolean,
			default: false
		},
		fullView: {
			type: Boolean,
			default: false
		},
		denseInput: {
			type: Boolean,
			default: true
		},
		inputLabel: {
			type: String,
			default: 'Proyecto'
		}
	},
	watch: {
		projectType(newValue){
			this.selectedProjectType = newValue
		}
	},
	data(){
		return {
			searchProjectTypeInput: null,
			hideSubTypes: [],
			selectedProjectType: null
		}
	},
	mounted(){
		this.selectedProjectType = this.projectType
	},
	computed: {
		projectTypeSubtitle() {
			const parentName = this.selectedProjectType?.parent?.name || '';
			const categoryName = this.selectedProjectType?.category?.name || '';

			if (parentName && categoryName) {
					return `${categoryName} | ${parentName}`;
			}
			return parentName || categoryName || '';
		},
		companiesProjectTypesCategories() {
			const search = this.searchProjectTypeInput?.trim().toLowerCase();
			if (search) {
					return this.$store.state.companies.companiesProjectTypesCategories
							.map(category => {
									const filteredProjectTypes = category.project_types
											.map(pt => {
													const hasMatch = pt.name.toLowerCase().includes(search);
													const filteredSubTypes = pt.sub_types?.filter(st =>
															st.name.toLowerCase().includes(search)
													) || [];
													if (hasMatch || filteredSubTypes.length > 0) {
															return {
																	...pt,
																	sub_types: filteredSubTypes
															};
													}
													return null;
											})
											.filter(Boolean);
									if (filteredProjectTypes.length > 0) {
											return {
													...category,
													project_types: filteredProjectTypes
											};
									}
									return null;
							})
							.filter(Boolean);
			}
			return this.$store.state.companies.companiesProjectTypesCategories;
		},
	},
	methods: {
		handleOpenSubTypes(project_type) {
			this.hideSubTypes = this.hideSubTypes.includes(project_type.id)
					? this.hideSubTypes.filter(id => id !== project_type.id)
					: [...this.hideSubTypes, project_type.id];
		},
		projectTypeChange(project_type) {
			if(project_type.sub_types?.length){
				this.handleOpenSubTypes(project_type)
			}
			else{
				this.$refs.projectTypeSelectMenu.isActive = false
				this.onClick(project_type)
			}
		}
	}
}
</script>